import { ReactNode, ElementType, DetailedHTMLProps, HTMLAttributes } from 'react';

/** 属性定義 */
type Props = {
  children: ReactNode;
  as: ElementType<DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>>;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtHeading = ({ children, as: Tag }: Props) => {
  return <Tag className='atheading'>{children}</Tag>;
};
/** 初期値の設定 */
AtHeading.defaultProps = {};
export default AtHeading;
